import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../util';
import Device from '../../lib/device';
import SigninForm from './signin-form';
import SignupForm from './signup-form';
import Spinner from '../../components/spinner';
import FbLoginButton from '../../components/fb-login-button';

class SigninSignup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSignupForm: true,
    };
    this.login = this.login.bind(this);
    this.signup = this.signup.bind(this);
    this.switchMode = this.switchMode.bind(this);
    this.onFacebookLogin = this.onFacebookLogin.bind(this);
  }

  signup(signupData) {
    this.props.actions.user.registerStart();
    this.props.services.user.register(
      {
        ...signupData,
        app: this.props.app.id,
        device: Device.UUID(),
      },
      'id name lastName email accessToken',
      this.props.actions.user,
      {},
    );
  }

  onFacebookLogin(token) {

    const data = {
      app: this.props.app.id,
      fbAccessToken: token,
      device: Device.UUID(),
    };
    const fragment = 'id name lastName email accessToken facebookId';
    this.props.services.user.facebookLogin(data, fragment, this.props.actions.user, {});
  }

  login(loginData) {
    const data = {
      ...loginData,
      app: this.props.app.id,
      device: Device.UUID(),
    };

    this.props.services.user.authenticate(
      data,
      'id name lastName email accessToken facebookId',
      this.props.actions.user,
      {},
    );
    
  }

  switchMode() {
    this.setState({ showSignupForm: !this.state.showSignupForm });
  }

  render() {
    if (this.props.user.isFetching || this.props.app.isFetching) {
      return (
        <main className="userContainer">
          <div className="container--loading">
            <Spinner size="large" />
          </div>
        </main>
      );
    }
    return (
      <main className="userContainer">
        <div className="signinSignup">
          <header>
            <h4 className="viewTitle">Ci siamo quasi!</h4>
            <p>Per completare il tuo ordine, devi prima effettuare l'accesso.</p>
          </header>
          {this.state.showSignupForm &&
            <div>
              <SignupForm
                onSave={this.signup}
                onCancel={this.switchMode}
              />
            </div>
          }
          {!this.state.showSignupForm &&
            <div>
              <SigninForm
                onSave={this.login}
                onCancel={this.switchMode}
              />
            </div>
          }
          <FbLoginButton user={{}} onLogin={this.onFacebookLogin} />

          <a
            href={`https://account.ristoranti.it/${this.props.app.id.replace(/^app-/, '')}/reset-password`}
            target="_blank"
            style={{
              display: 'block',
              textAlign: 'center',
              padding: '0 1em',
              fontSize: '0.8em',
            }}
          >
            Ho dimenticato la password
          </a>
        </div>
      </main>
    );
  }
}

SigninSignup.propTypes = {
  app: PropTypes.shape({
    id: PropTypes.string,
    isFetching: PropTypes.bool,
  }),
  user: PropTypes.shape({
    currentUser: PropTypes.shape({}),
    isFetching: PropTypes.bool,
  }),
};

const mapStateToProps = (state, props) => ({
  app: state.app,
  user: state.user,
});

export default connect(SigninSignup, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/user/signin-signup.js